const SELECTED_CONTRACT_PARAM = 'contract';
const SELECTED_ITEM_PARAM = 'item';

const COMMERCIALIZATION_MENU_DISABLE_FLAG =
  'commercializationDisableMenuAccess';
const COMMERCIALIZATION_TAB_FEATURE_FLAGS = {
  CONTRACTS: 'contractsDisableMenuAccess',
  STOCK: 'accountsPayableDisableMenuAccess',
  MOVEMENTS: 'movementsDisableMenuAccess',
} as const;

const STOCK_FILTER_KEYS = ['warehouses', 'products'] as const;
const CONTRACT_FILTER_KEYS = ['farms', 'customers', 'products'] as const;

export {
  COMMERCIALIZATION_MENU_DISABLE_FLAG,
  COMMERCIALIZATION_TAB_FEATURE_FLAGS,
  CONTRACT_FILTER_KEYS,
  SELECTED_CONTRACT_PARAM,
  SELECTED_ITEM_PARAM,
  STOCK_FILTER_KEYS,
};
